import type { ReactElement } from 'react';
import { SchedulerWorkspace } from '../scheduler/SchedulerWorkspace';
import { SegueWorkspace } from '../segue/SegueWorkspace';
import { ListenerPlayer } from '../listener/ListenerPlayer';
import { DesktopStudio } from '../studio/DesktopStudio';
import { MobileDj } from '../mobile/MobileDj';
import { GuestStudio } from '../guest/GuestStudio';
import { MonitoringWorkspace } from '../monitoring/MonitoringWorkspace';
import { AccountSecurity } from '../auth/AccountSecurity';
import { StationsWorkspace } from '../stations/StationsWorkspace';
import { AuthGate } from '../auth/AuthGate';
import { PlatformFrame } from '../auth/PlatformFrame';
import { resolveApp } from './appRegistry';

interface AppProps {
  path: string;
}

export function App({ path }: AppProps): ReactElement {
  const registration = resolveApp(path);

  if (registration.audience === 'authenticated') {
    return <AuthGate path={path}>{({ api, user, sessionKey, endSession }) => <PlatformFrame api={api} user={user} path={path} onSignedOut={endSession}>
      <div key={sessionKey}>{protectedWorkspace(registration.kind, path, api, user, endSession)}</div>
    </PlatformFrame>}</AuthGate>;
  }

  if (registration.kind === 'listener') return <ListenerPlayer />;
  if (registration.kind === 'guest') return <GuestStudio />;

  return (
    <main className="skeleton" data-app={registration.kind}>
      <p className="eyebrow">ПЛАТФОРМА</p>
      <h1>{registration.title}</h1>
      <p>
        Цей розділ зареєстровано, але його робочий інтерфейс ще не підключено.
      </p>
    </main>
  );
}

function protectedWorkspace(
  kind: ReturnType<typeof resolveApp>['kind'],
  path: string,
  api: Parameters<typeof AccountSecurity>[0]['api'],
  user: Parameters<typeof AccountSecurity>[0]['user'],
  endSession: Parameters<typeof AccountSecurity>[0]['onSessionEnded'],
): ReactElement {
  if (kind === 'account') return <AccountSecurity api={api} user={user} onSessionEnded={endSession} />;
  if (kind === 'login') return <SchedulerWorkspace />;
  if (kind === 'admin') {
    if (path.startsWith('/admin/monitoring')) return <MonitoringWorkspace />;
    if (path.startsWith('/admin/stations')) return <StationsWorkspace />;
    if (path.startsWith('/admin/segue') || path.startsWith('/admin/library')) return <SegueWorkspace />;
    return <SchedulerWorkspace />;
  }
  if (kind === 'dj-desktop') return <DesktopStudio />;
  if (kind === 'dj-mobile') return <MobileDj />;
  return <SchedulerWorkspace />;
}
